export const SET_ORDERS = 'SET_ORDERS'

const initialState = {
  items: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDERS:
      return {
        ...state,
        items: action.orders
      }
    default:
      return state
  }
}
